import { render, staticRenderFns } from "./TaskBlocksReader.vue?vue&type=template&id=5f71b8da&scoped=true&"
import script from "./TaskBlocksReader.vue?vue&type=script&lang=js&"
export * from "./TaskBlocksReader.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlocksReader.vue?vue&type=style&index=0&id=5f71b8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f71b8da",
  null
  
)

export default component.exports